import React from "react";

import ArticleStyle from "../components/article/ArticleStyle";
import CatDivider from "../components/common/CatDivider";
import CenterContent from "../components/common/CenterContent";
import HomeHelmet from "../components/home/HomeHelmet";
import listCatalogue from "../catalogue/list-catalogue";
import Page from "../components/common/Page";
import style from "./lists.module.css";
import ListCard from "../components/list/ListCard";

const ListsPage = () => (
  <Page>
    <HomeHelmet
      path="/lists/"
      description="Curated lists of libraries, tools, and articles: instantly find the best tool for your needs."
    />
    <div className={style.intro}>
      <CenterContent wide>
        <ArticleStyle>
          <h1>Lists</h1>
          <p>
            Ever spent hours looking for the right dependency only to come up
            empty handed? Or worse - picked a library only to realize weeks
            later that you missed a better option?
          </p>
          <p>
            With hundreds of thousands of packages on npm, it can be difficult
            to find the best library. In fact, it can take all day just to find
            out what your options are.
          </p>
          <p>
            That's where these lists come in: curated lists of libraries that
            are both sortable and filterable. Instantly see what packages are
            available. Then sort and filter to hone in on the perfect fit for
            your project.
          </p>
        </ArticleStyle>
      </CenterContent>
    </div>
    <div className={style.listOuter}>
      <CenterContent wide>
        <div className={style.list}>
          {listCatalogue.map(list => <ListCard key={list.path} list={list} />)}
        </div>
      </CenterContent>
    </div>
    <CatDivider />
  </Page>
);
export default ListsPage;



// WEBPACK FOOTER //
// ./src/pages/lists.js